// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__9BjXa","rotation":"styles_rotation__YBw+x"};